import { useState, useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiService } from '../services/api';

export interface DefaultExerciseSettings {
  sets: number;
  reps: number;
  weight: number;
  rest_time: number; // в секундах
}

export const useDefaultExerciseSettings = () => {
  const queryClient = useQueryClient();

  // Загрузка настроек
  const { data: settings, isLoading, error } = useQuery(
    'default-exercise-settings',
    () => apiService.getDefaultExerciseSettings(),
    {
      staleTime: 5 * 60 * 1000, // 5 минут
      cacheTime: 10 * 60 * 1000, // 10 минут
    }
  );

  // Сохранение настроек
  const saveSettingsMutation = useMutation(
    (newSettings: DefaultExerciseSettings) => apiService.saveDefaultExerciseSettings(newSettings),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('default-exercise-settings');
      },
    }
  );

  // Получение веса для конкретного упражнения на основе истории
  const getExerciseWeight = async (exerciseId: number, clientId?: number): Promise<number> => {
    try {
      return await apiService.getExerciseWeightFromHistory(exerciseId, clientId);
    } catch (error) {
      console.log('Не удалось получить вес из истории:', error);
      return 0;
    }
  };

  return {
    settings: settings || {
      sets: 3,
      reps: 10,
      weight: 0,
      rest_time: 90
    },
    isLoading,
    error,
    saveSettings: saveSettingsMutation.mutate,
    isSaving: saveSettingsMutation.isLoading,
    getExerciseWeight,
  };
}; 